




















import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'

@Component
export default class ScoreInput extends Vue {
  @Prop()
  private value!: number

  @Prop()
  private target!: number

  @Prop({ default: '' })
  private colClass!: string

  private score = this.value

  @Watch('value')
  private valueUpdated(val: number) {
    this.score = val
  }

  @Watch('score')
  private scoreUpdated(val: number) {
    this.$emit('input', val)
  }
}
